module.exports = __webpack_public_path__ + "static/media/favorites-icon.644428fa.svg";